import '@Global/modal';
import '@Global/create-from-scratch';

import App from '@Components/app';
import {ModalContainer} from '@Components/modal-container';
import type {ReactElement} from 'react';
import {LoadingToast} from '@Components/loading-toast';
import ModalContainerDeprecated from '@Components/modal-container-deprecated/modal-container';
import {renderApp} from '@Utils/renderApp.util';

export function CreateFromScratchApp(): ReactElement {
  return (
    <App>
      <ModalContainerDeprecated />
      <ModalContainer />
      <LoadingToast />
    </App>
  );
}

renderApp(<CreateFromScratchApp />, 'create-from-scratch-app');